export default function (invito) {
  this.Invito = invito ? invito.Invito : null;
  this.abilitatoPrenotazione = invito ? invito.abilitatoPrenotazione : false;
  this.abilitatoIscrizione = invito ? invito.abilitatoIscrizione : false;
  this.blobImage = invito ? invito.blobImage : null;
}